import IconButtonDo from "../../../../../../packages/design-system/button/constellation/link-icon-button/images/dos-donts/icon-common-do.png";
import IconButtonDont from "../../../../../../packages/design-system/button/constellation/link-icon-button/images/dos-donts/icon-common-dont.png";
import * as React from 'react';
export default {
  IconButtonDo,
  IconButtonDont,
  React
};